import PersonaCobranzasView from "./PersonaCobranzasView";

export {PersonaCobranzasView}
export default PersonaCobranzasView
